import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { List, ListItem, NothingSelected } from './index';
import styled from 'styled-components';
import { CompleteBox } from './LessonList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import ActionsMenu from 'components/Course/ActionsMenu';

const SeriesName = styled.h3`
    font-size: 20px;
`;
const SeriesDescription = styled.p`
    font-size: 16px;
`;

const CourseList = ({ activeSeries, activeCourse, setActiveCourse }) => {
    const series = useSelector(state => state.courseList.series.series);
    const thisSeries = useMemo(() => {
        if (!series) return;
        return series[activeSeries];
    }, [series, activeSeries]);
    const courses = useMemo(() => {
        if (!thisSeries) return [];
        return thisSeries.courses || [];
    }, [thisSeries]);

    if (!thisSeries) {
        return <NothingSelected>Select a series</NothingSelected>;
    }

    return (
        <>
            <SeriesName>{thisSeries?.name}</SeriesName>
            <SeriesDescription>{thisSeries?.description}</SeriesDescription>
            <List $line>
                {(courses || []).map((item, index) => (
                    <ListItem key={index} onClick={() => setActiveCourse(index)} active={activeCourse === index}>
                        <CompleteBox $complete={item.complete}>
                            <FontAwesomeIcon icon={faCheck} className="checkmark" />
                        </CompleteBox>
                        <div className="name">{item.name}</div>
                        <ActionsMenu course={item} />
                    </ListItem>
                ))}
            </List>
        </>
    );
};

export default CourseList;
